import { Map, Set, List, OrderedMap } from 'immutable';

import * as types from './types';
import { formatDuration as formatTime } from './../../time';
import { MetricsRecord } from './../../records';

const initialState = Map({
  testNames: Set(),
  tests: [],
  selectedTests: Map(),
  testSearchValue: '',
  metrics: OrderedMap({
    runs: new MetricsRecord({
      title: 'Total runs',
      labelClassName: 'blue',
    }),
    errors: new MetricsRecord({
      title: 'Total errors',
      labelClassName: 'warning',
    }),
    fails: new MetricsRecord({
      title: 'Total Failures',
      labelClassName: 'danger',
    }),
    average: new MetricsRecord({
      title: 'Average Runtime',
    }),
  }),
  selectedTestGroup: null,
  histogramInterval: '',
  testsInGroup: Map({
    loading: false,
    error: false,
    items: List(),
  }),
});


const testHistoryReducer = (state = initialState, { type, payload, error }) => {
  switch (type) {
    case types.SET_TEST_SEARCH_VALUE:
      return state
        .set('testSearchValue', payload)
        .set('testNames', Set());
    case types.GET_TEST_NAMES.REQUEST:
      return state.set('testNames', Set());
    case types.GET_TEST_NAMES.SUCCESS:
      return state
        .withMutations((newState) => {
          newState.set('testNames', Set(payload.items.map((item) => item.name)));
        });
    // get test metrics
    case types.GET_TEST_METRICS.SUCCESS:
      return state.withMutations((newState) => {
        const {
          count,
          statuses,
          avgRunTime,
        } = payload.aggs;
        // TODO(adam): omit `statuses` from the backend response if there is no data.
        // Currently, it can be `null` and default value does not work.
        const { errored = 0, failed = 0 } = (statuses || {});

        newState.setIn(['metrics', 'runs', 'value'], count);
        newState.setIn(['metrics', 'errors', 'value'], errored);
        newState.setIn(['metrics', 'fails', 'value'], failed);
        newState.setIn(
          ['metrics', 'average', 'value'],
          avgRunTime ? formatTime(avgRunTime) : null,
        );
      });
    case types.GET_PREVIOUS_TEST_METRICS.REQUEST:
      return state;
    case types.GET_PREVIOUS_TEST_METRICS.SUCCESS:
      return state.withMutations((newState) => {
        const { count, statuses = {} } = payload.aggs;
        // TODO(adam): omit `statuses` from the backend response if there is no data.
        // Currently, it can be `null` and default value does not work.
        const { errored = 0, failed = 0 } = (statuses || {});

        newState.setIn(['metrics', 'runs', 'previousValue'], count);
        newState.setIn(['metrics', 'errors', 'previousValue'], errored);
        newState.setIn(['metrics', 'fails', 'previousValue'], failed);
      });
    case types.GET_PREVIOUS_TEST_METRICS.FAILURE:
      return state;
    case types.GET_TESTS.REQUEST:
      return state.withMutations((newState) => {
        // if there is no 'from' param, it means we start getting tests from scratch
        if (!payload.from) {
          newState.set('tests', []).set('selectedTests', Map());
        }

        return newState;
      });
    case types.GET_TESTS.SUCCESS:
      return state.withMutations((newState) => {
        if (payload.meta && payload.meta.histogram_interval) {
          newState.set('histogramInterval', payload.meta.histogram_interval);
        }

        newState.update('tests', (tests) => tests.concat(
          payload.items.map(
            (item) => ({ ...item, timestamp: Date.parse(item.datetime || item.creation_time) }),
          ),
        ));
      });
    case types.ADD_TO_SELECTED_TESTS:
      return state.setIn(['selectedTests', payload.id], payload);
    case types.REMOVE_FROM_SELECTED_TESTS:
      return state.deleteIn(['selectedTests', payload.id]);
    case types.CLEAR_SELECTED_TESTS:
      return state.withMutations((newState) => {
        // Reset tests to clear selected point from scatterplot
        newState
          .set('selectedTests', Map())
          .set('tests', state.get('tests').slice(0));
      });
    case types.SELECT_TEST_GROUP:
      return state.set('selectedTestGroup', Map(payload));
    case types.DESELECT_TEST_GROUP:
      return state.set('selectedTestGroup', null);
    case types.CLEAR_TESTS_IN_GROUP:
      return state.setIn(['testsInGroup', 'items'], List());
    case types.GET_TESTS_IN_GROUP.REQUEST:
      return state.setIn(['testsInGroup', 'loading'], true);
    case types.GET_TESTS_IN_GROUP.SUCCESS:
      return state.withMutations((newState) => {
        newState
          .setIn(['testsInGroup', 'loading'], false)
          .setIn(['testsInGroup', 'items'], List(payload.items))
          .setIn(['testsInGroup', 'error'], false);
      });
    case types.GET_TESTS_IN_GROUP.FAILURE:
      return state.withMutations((newState) => {
        newState
          .setIn(['testsInGroup', 'loading'], false)
          .setIn(['testsInGroup', 'items'], List())
          .setIn(['testsInGroup', 'error'], error);
      });
    default:
      return state;
  }
};

export default testHistoryReducer;
export { initialState };
